<template>
  <c-modal :active="displayModal" :title="title" :disable-scroll="true" class-name="move-field-modal" @close="close">
    <form class="move-form" @submit.prevent="submit">
      <div class="form-group move-form__tab">
        <c-input v-model="tab" type="select" label="Вкладка назначения" :searchable="true" :items="tabsList" />
      </div>
    </form>

    <template #actions>
      <c-button size="large" label="Отменить" @click="close" />
      <c-button label="Перенести" color="primary" size="large" :disabled="pending" :pending="pending" @click="submit" />
    </template>
  </c-modal>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import CModal from "@/components/scrollable-modal";

export default {
  components: {
    CInput,
    CButton,
    CModal,
  },
  props: ["tabs"],
  data() {
    return {
      displayModal: false,
      field: null,
      isSubmitted: false,
      pending: false,
      currentTab: null,
      tab: null,
    };
  },

  computed: {
    title() {
      return `Перенести поле/блок <span class="field-name">${this.field ? this.field.name : ""}</span>`;
    },
    tabsList() {
      return this.tabs.map((tab) => ({ value: tab.id, label: tab.name }));
    },
  },

  methods: {
    open(field, tabId) {
      this.field = field;
      this.currentTab = tabId;
      this.tab = { value: tabId };
      this.displayModal = true;
    },

    close() {
      this.displayModal = false;
      this.reset();
      this.$emit("close");
    },

    reset() {
      this.isSubmitted = false;
      this.isPending = false;
    },

    getParams() {
      const params = {
        id: this.field.id,
        newTabId: this.tab.value,
        oldTabId: this.currentTab,
      };

      return params;
    },

    submit() {
      this.isSubmitted = true;

      this.pending = true;
      const params = this.getParams();

      this.$store.dispatch("profile/moveFieldToTab", params).then(() => {
        this.pending = false;

        this.$emit("updated", {
          field: this.field,
          oldTabId: this.currentTab,
          newTabId: this.tab.value,
        });

        const tabData = this.tabs.find(t => t.id === this.tab.value);

        this.$notify({
          group: "success-message",
          data: {
            textMessage: `Параметр <b>${this.field.name}</b> успешно перенесен на вкладку <b>${tabData.name}</b>`,
          },
        });
        this.close();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.move-form {
  &__tab {
    padding-top: 6px;
  }
}
</style>

<style lang="scss">
.move-field-modal {
  max-width: 590px !important;
  .field-name {
    font-weight: 400;
  }
}
</style>
